export const RUN_COMPUTER_USE_TOOL_NAME = 'run_computer_use_task';
/** Read-only AX note-push field discovery child (ml-scribe run-scoped binding). */
export const DISCOVER_NOTE_PUSH_FIELDS_TOOL_NAME = 'discover_note_push_fields';
/** Confirmed note-push write child (ml-scribe run-scoped binding). */
export const PUSH_CONFIRMED_NOTE_TOOL_NAME = 'push_confirmed_note';
export const COMPUTER_USE_APPROVAL_KIND = 'computer_use';

const COMPUTER_USE_TOOL_NAMES: ReadonlySet<string> = new Set([
  RUN_COMPUTER_USE_TOOL_NAME,
  DISCOVER_NOTE_PUSH_FIELDS_TOOL_NAME,
  PUSH_CONFIRMED_NOTE_TOOL_NAME,
]);

/** Keyed on tool names, not approval kind alone: auto-approve creates no approval record. */
export function deriveIsComputerUse(args: {
  toolName: string;
  approvalKind?: string | null;
}): boolean {
  return (
    COMPUTER_USE_TOOL_NAMES.has(args.toolName.toLowerCase()) ||
    args.approvalKind === COMPUTER_USE_APPROVAL_KIND
  );
}
